import { PortalProductConfig, getProductWithVariants, ProductWithVariants } from '../../models/product';
import { SingleInsurantWidgetComponent } from '../../customer-portal/widgets/single-insurant-widget/single-insurant-widget.component';
import { defaultContractWidgets } from '../../config/default-contract-widgets';

const portalConfig: PortalProductConfig = {
    icon: 'musician',
    widgets: [...defaultContractWidgets, { component: SingleInsurantWidgetComponent }],
};

export const musicInstrumentInsuranceForPupils: ProductWithVariants = getProductWithVariants({
    slug: 'musikinstrumentenversicherung-schueler',
    title: 'Musikinstrumentenversicherung für Schüler',
    fullTitle: 'Musikinstrumentenversicherung für Schüler',
    collapsableTitle: 'Musikinstrumenten&shy;versicherung für Schüler',
    insuranceTypeName: 'Musik Schüler',
    insuranceTypeId: 5,
    legacy: true,
    portalConfig,
});
